<template>
  <div class="report-container">
    <el-alert center type="info">
      Switch to <router-link class="router-link" :to="{ name: 'priorYearReportNewVsReturning' }">Prior Year
        Report</router-link>
    </el-alert>
    <el-row :gutter="18">
      <el-col :span="24" class="mb-3">
        <div class="chart-holder">
          <new-vs-returning-chart :date-range="dateRange" :for-office="selectedOffice"></new-vs-returning-chart>
        </div>
      </el-col>
      <el-col :span="24" class="mb-3">
        <office-nvr-table :date-range="dateRange" :for-office="selectedOffice"></office-nvr-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import NewVsReturningChart from '@/components/charts/NewVsReturning';
import OfficeNvrTable from '@/components/tables/OfficeNvR.vue';
import ReportBaseMixin from '@/views/reports/ReportBaseMixin';

export default {
  components: {
    NewVsReturningChart,
    OfficeNvrTable,
  },
  mixins: [
    ReportBaseMixin,
  ],
};

</script>
